/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    MESSAGE_DETAILS: 'Détails du message',
    OK: 'OK'
  },
  ERROR: {
    ERROR: 'Erreur',
    FETCH_DATA: 'Récupérer des données',
    NO_ORDER: 'Impossible de passer la commande'
  },
  HEADER: {
    DATE: 'Date',
    MESSAGE: 'Message',
    NAME: 'Nom du client',
    ORDER_CODE: 'Code de commande',
    ORDER_DATE: 'Date de commande',
    ORDER_ID: 'Commande',
    ORDER_VALUE: 'Montant',
    PAYMENT_DATE: 'Date de paiement',
    PAYMENT_STATE: 'État du paiement',
    PRICE: 'Prix',
    VALUE: 'Montant'
  },
  LABEL: {
    COPIED: 'Copié!',
    EXPORT: 'Exporter',
    GIVEWAY_DATE: 'Date du tirage au sort :',
    MONTH: 'Mois',
    ORDER_PRIZE_MSG: 'L\'ordre tiré était:',
    PAYED: 'Payé',
    PRIZE: 'Giveaway',
    RAFFLE: 'Giveaway',
    UNPAYED: 'Non payé',
    UNTIL: 'until',
    YEAR: 'Année'
  },
  SENTENCE: {
    NO_ROWS_ORDER_MESSAGES: 'Aucun message',
    NO_ROWS_ORDER_MESSAGES_DESCRIPTION:
      'Aucun message du client (pour l\'instant).',
    NO_ROWS_ORDERS: 'Aucun commande',
    NO_ROWS_ORDERS_DESCRIPTION: 'Aucun commande (pour l\'instant).'
  },
  SUCCESS: {
    SUCCESS: 'Succès'
  },
  TOOLTIP: {
    DATE: 'Date',
    ORDER_CODE: 'Code de commande',
    ORDER_ID: 'Commande',
    PAYMENT_DATE: 'Date de paiement',
    PAYMENT_STATE: 'État du paiement',
    PRICE: 'Prix',
    VALUE: 'Montant'
  }
};
